import React, { forwardRef, useRef } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DayPickerProps } from 'react-day-picker/types/Props';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { theme } from 'design';
import { useWindowSize } from 'hooks';
import ReactDayPickerInput from './ReactDayPickerInput';

dayjs.extend(customParseFormat);

interface IReactDatePickerProps {
  value?: Date | string;
  onChange?: (dateString: string) => void;
  dayPickerProps?: DayPickerProps;
  onDayPickerShow?: () => void;
  onDayPickerHide?: () => void;
  onSubmit?: (day?: string) => void;
}

const ReactDatePicker = ({ value, onChange, dayPickerProps, onDayPickerShow, onDayPickerHide, onSubmit, ...rest }: IReactDatePickerProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const windowSize = useWindowSize();

  return (
    <DayPickerInput
      component={forwardRef((props, ref) => (
        <ReactDayPickerInput {...props} innerRef={ref} readOnly={windowSize.width <= theme.breakpoint.small} />
      ))}
      value={value}
      inputProps={{
        ref,
        onBlur: (e: React.FormEvent<HTMLInputElement>) => {
          onChange?.(e.currentTarget.value);
        },
      }}
      placeholder={`${dayjs().format('MM-DD-YYYY')}`}
      formatDate={(date: Date) => {
        if (dayjs(date).isValid()) {
          return dayjs(date).format('MM-DD-YYYY');
        }
        return value as string;
      }}
      onDayChange={async (day: Date) => {
        if (day) {
          await onChange?.(dayjs(day).format('MM-DD-YYYY'));
          await onSubmit?.(dayjs(day).format('MM-DD-YYYY'));
        }
      }}
      dayPickerProps={dayPickerProps}
      onDayPickerShow={onDayPickerShow}
      onDayPickerHide={onDayPickerHide}
      {...rest}
    />
  );
};

export default ReactDatePicker;
